import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
document.title = 'Atlas Ancestral de Acupuntura™ | Lumen Akasha';

// Meta Pixel Code
const initMetaPixel = () => {
  if (typeof window === 'undefined') return;

  // @ts-ignore
  !function (f, b, e, v, n, t, s)
  // @ts-ignore
  {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ?
      // @ts-ignore
      n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    // @ts-ignore
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    // @ts-ignore
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    // @ts-ignore
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    // @ts-ignore
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // @ts-ignore
  fbq('init', '2100786177979954');
  // @ts-ignore
  fbq('track', 'PageView');
};
initMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-301" data-mp="1alyl63yn510u" />);
}